// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_COMMENT = "Naozaj chce\u0161 zmaza\u0165 koment\u00e1r?";
export const THE_POST_WAS_BLOCKED = "Pr\u00edspevok bol pozastaven\u00fd.";
